interface CpmBandChipProps {
    band: string;
    className?: string;
}

/** Counter Flow `bandChip()` — confidence band colors (not status lifecycle). */
const BAND_STYLES: Record<string, string> = {
    VERY_HIGH:
        'bg-[var(--cpm-success-bg)] border-[var(--cpm-success-border)] text-[var(--cpm-success-text-light)]',
    HIGH: 'bg-[var(--cpm-success-bg)] border-[var(--cpm-success-border)] text-[var(--cpm-success-text-light)]',
    MODERATE:
        'bg-[var(--cpm-warning-bg)] border-[var(--cpm-warning-border)] text-[var(--cpm-warning-text)]',
    LOW: 'bg-[var(--cpm-shortfall-bg)] border-[var(--cpm-shortfall-border)] text-[var(--cpm-shortfall-text)]',
};

export default function CpmBandChip({ band, className = '' }: CpmBandChipProps) {
    const normalized = String(band ?? '').trim();
    const key = normalized.toUpperCase();
    const style = BAND_STYLES[key] ?? BAND_STYLES.MODERATE;
    const label = normalized ? normalized.replaceAll('_', ' ') : '—';

    // Design `bandChip()` — inline-flex pill, no alignSelf centering (that broke
    // left-aligned stacks in Link Review "Confidence & method").
    return (
        <span
            className={[
                'inline-flex items-center px-[9px] py-[3px] rounded-full border text-[10px] font-extrabold tracking-[0.05em] whitespace-nowrap',
                style,
                className,
            ].join(' ')}
        >
            {label}
        </span>
    );
}
